import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("trital_token"));
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const stored = localStorage.getItem("trital_token");
    if (!stored) { setUser(null); setToken(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setToken(stored);
    } catch {
      localStorage.removeItem("trital_token");
      setUser(null);
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  /* Direct setter — used by the marketplace signup/login pages
     after they've POSTed to /auth/register or /auth/login themselves. */
  const setSession = (newToken, newUser) => {
    if (newToken) localStorage.setItem("trital_token", newToken);
    setToken(newToken || null);
    setUser(newUser || null);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("trital_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("trital_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("trital_token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, token, loading, login, register, logout, setSession, refresh: fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
